export const MORTGAGE_DEFAULT_PROPERTY_PRICE = 5_000_000;
export const MORTGAGE_DEFAULT_LOAN_VALUE = 4_000_000;
export const MORTGAGE_DEFAULT_YEARS = 30;

export const AMERICAN_MORTGAGE_DEFAULT_LOAN_VALUE = 1_000_000;
export const AMERICAN_MORTGAGE_DEFAULT_YEARS = 15;

export const REFINANCING_DEFAULT_YEARS = 20;
export const REFINANCING_DEFAULT_PAID_YEARS = 5;

export const CONSUMER_LOAN_DEFAULT_YEARS = 5;

export const PENSION_ANNUITY_DEFAULT_DURATION = 15;
export const PENSION_ANNUITY_DEFAULT_YEARS_UNTIL = 20;

export const CHILDREN_SAVINGS_YEARS_DEFAULT = 18;

export const GOAL_ACHIEVE_YEARS_DEFAULT = 4;
